import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import { IntTooltipComponent } from "./int-tooltip.component";

@NgModule({
  declarations: [
    IntTooltipComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IntTooltipComponent
  ]
})
export class IntTooltipModule { }